<button
    *ngIf="task.state === DeliveryTaskState[DeliveryTaskState.WaitingForAccept]"
    class="btn btn-block btn-primary"
    (click)="acceptDelivering()"
>
    {{ 'my-tasks.accept-task' | translate }}
</button>
<button
    *ngIf="task.state === DeliveryTaskState[DeliveryTaskState.ToDo]"
    class="btn btn-block btn-primary"
    [ngClass]="{
        'hs-cta-trigger-button hs-cta-trigger-button-173107611190': countryCode === 'at',
    }"
    (click)="startDelivering()"
>
    {{ 'my-tasks.start-delivering' | translate }}
</button>
<div
    class="btn-group btn-block"
    *ngIf="task.state === DeliveryTaskState[DeliveryTaskState.InProgress] && getIsPaid()"
>
    <button
        *ngIf="!isDeliveryDoneInProgress"
        (click)="setDeliveringDoneWithLatLong()"
        class="btn btn-success"
        [ngClass]="{
        'hs-cta-trigger-button hs-cta-trigger-button-173107611190': countryCode === 'at',
    }"
    >
        {{ 'common.done' | translate }}
    </button>
    <button
        *ngIf="!isDeliveryDoneInProgress"
        (click)="setDeliveringFailed()"
        class="btn btn-danger"
    >
        {{ 'common.failed' | translate }}
    </button>
    <div *ngIf="isDeliveryDoneInProgress">
        <div class="spinner-border text-primary" role="status">
            <i class="fa fa-spinner fa-spin loading-icon-custom" aria-hidden="true"></i>
        </div>
        <span class="sr-only">{{ 'common.delivery-done-loading-text' | translate }}</span>
    </div>
</div>

<div class="btn-group btn-block" *ngIf="showPaymentButton()">
    <button
        (click)="handleSumUpPay()"
        class="btn btn-primary"
        [ngClass]="{ 'btn-info': isButtonBlocked }"
    >
        {{ 'common.payment' | translate }}
    </button>
</div>

<div class="btn-group btn-block" *ngIf="showCashOnDeliveryButton()">
    <button
        (click)="openCashAcceptanceModale()"
        class="btn btn-primary"
        [ngClass]="{ 'btn-info': isButtonBlocked }"
    >
        {{ 'common.cash-on-delivery-payment' | translate }}
    </button>
</div>

<small class="mt-2"
    >{{ detroyedComponent }} <br />
    {{ paymentStatus }}</small
>

<app-location-check-modal></app-location-check-modal>

<lib-modal
    [title]="'my-tasks.cash-acceptance-modal'"
    [componentID]="'app-cash-acceptance-modal' + task.deliveryTaskID"
    [bgColorClass]="ColorClass.Success"
>
    <p>{{ 'my-tasks.cash-acceptance-modal-text' | translate }}</p>
    <form
        [formGroup]="cashPaymentForm"
        (ngSubmit)="onSubmit()"
        class="p-4 border rounded shadow-sm bg-light"
    >
        <!-- Beszedendő összeg (fix) -->
        <div class="mb-3">
            <label class="form-label"
                >{{ 'my-tasks.cash-total-to-get' | translate }}
            </label>
            <input class="form-control" [value]="customerPaidTotalPrice" readonly />
        </div>

        <!-- Vásárlótól átvett összeg -->
        <div class="mb-3">
            <label class="form-label"
                >{{ 'my-tasks.customer-paid-cash' | translate }}
            </label>
            <input
                type="number"
                formControlName="amountReceivedFromCustomer"
                class="form-control"
                [class.is-invalid]="
                    cashPaymentForm.get('amountReceivedFromCustomer')?.invalid &&
                    cashPaymentForm.get('amountReceivedFromCustomer')?.touched
                "
            />
            <div
                class="invalid-feedback"
                *ngIf="cashPaymentForm.get('amountReceivedFromCustomer')?.hasError('min')"
            >
                {{ 'my-tasks.customer-paid-cash-error-text' | translate }}
            </div>
        </div>

        <!-- Visszajáró a vásárlónak -->
        <div class="mb-3">
            <label class="form-label">{{ 'my-tasks.change-for-user' | translate }}</label>
            <input class="form-control" formControlName="changeDueToCustomer" readonly />
        </div>

        <!-- Vásárlónak átadott visszajáró -->
        <div class="mb-3">
            <label class="form-label">
                {{ 'my-tasks.given-change-for-user' | translate }}
            </label>
            <input
                type="number"
                formControlName="changeGivenToCustomer"
                class="form-control"
                [class.is-invalid]="
                    cashPaymentForm.get('changeGivenToCustomer')?.invalid &&
                    cashPaymentForm.get('changeGivenToCustomer')?.touched
                "
            />
            <div
                class="invalid-feedback"
                *ngIf="
                    cashPaymentForm
                        .get('changeGivenToCustomer')
                        ?.hasError('changeTooMuch')
                "
            >
                {{ 'my-tasks.given-change-for-user-error-text' | translate }}
            </div>
        </div>

        <div
            class="mb-3 text-muted"
            *ngIf="
                cashPaymentForm.get('changeDueToCustomer')?.value != null &&
                cashPaymentForm.get('changeGivenToCustomer')?.value != null &&
                cashPaymentForm.get('changeDueToCustomer')?.value -
                    cashPaymentForm.get('changeGivenToCustomer')?.value >
                    0
            "
        >
            <small>
                {{ 'my-tasks.cash-back-difference' | translate }}:
                {{
                    cashPaymentForm.get('changeDueToCustomer')?.value -
                        cashPaymentForm.get('changeGivenToCustomer')?.value | priceround
                }}
                {{ 'common.currency' | translate }}
            </small>
        </div>

        <div class="btn-toolbar justify-content-between text-center mt-2">
            <div class="btn-group m-auto">
                <button
                    class="btn btn-success"
                    type="submit"
                    [disabled]="cashPaymentForm.invalid"
                >
                    <i class="fa fa-check"></i>{{ 'my-tasks.accept-cash' | translate }}
                </button>
                <button type="button" class="btn btn-danger" (click)="closeModal()">
                    <i class="fa fa-undo"></i>{{ 'common.cancel' | translate }}
                </button>
            </div>
        </div>
    </form>
</lib-modal>

<!-- <lib-modal [componentID]="'app-cash-acceptance-modal' + task.deliveryTaskID">
    <app-cash-acceptance-modal
        [task]="task"
        (onPayOnDeliveryCashCloseModal)="onPayOnDeliveryCashCloseModal($event)"
    ></app-cash-acceptance-modal>
</lib-modal> -->
